import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
const API_HOST = process.env.REACT_APP_API_URL;

const BloggerLogin = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();


  useEffect(() => {
    // If authToken exists in session storage, redirect to the admin dashboard
    if (sessionStorage.getItem("authToken")) {
      const userType = sessionStorage.getItem("userType");
      if (userType === "blogger") {
        navigate("/blogger");
      } else if (userType === "admin") {
      navigate("/admin/admin-dashboard");
      }
      else if(userType === "blogHead"){
         navigate("/blogHead/blogs");
      }
    }
  }, [navigate]);

  const handleSubmit = async (event) => {
    event.preventDefault();
    try {
      const response = await fetch(`${API_HOST}auth/login`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ email, password }),
      });

      const data = await response.json();

      if (data.success) {
        sessionStorage.setItem("authToken", data.authToken);
        sessionStorage.setItem("userType", data.userType);
       
        if (data.userType === "admin") {
          navigate("/admin/admin-dashboard");
        } else if (data.userType === "blogger") {
          navigate("/blogger/"); // or your actual blogger route
        }else if(data.userType === "blogHead"){
         navigate("/blogHead/blogs");
      }
         else {
          setError("Unknown user type.");
          sessionStorage.removeItem("authToken");
        
        }

      } else {
        console.error("Login failed:", data.message);
        console.log(data);
        setError("Invalid credentials, please try again.");
      }
    } catch (error) {
      console.error("Error logging in:", error);
      setError("Something went wrong. Please try again later.");
    }
  };

  return (
    <div
      style={{
        height: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <div
        className="mb-20 mt-20"
        style={{
          width: "400px",
          padding: "40px",
          margin: "auto",
          border: "1px solid rgba(131, 131, 131, 0.5)",
          backgroundColor: "rgba(255, 255, 255, 0.1)",
          borderRadius: "8px",
        }}
      >
        <form className="contact-form pos-rel" onSubmit={handleSubmit}>
          <div className="row">
            <h3>Blogger Login</h3>
            {error && <p style={{ color: "red" }}>{error}</p>}
            <div className="col-lg-12">
              <div
                className="xb-item--field"
                style={{
                  borderTop: "0",
                  borderBottom: "1px solid rgba(131, 131, 131, 0.5)",
                }}
              >
                <label htmlFor="mail">Email</label>
                <input
                  id="mail"
                  type="email"
                  placeholder="genz@example.com"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
              </div>
            </div>
            <div className="col-lg-12">
              <div
                className="xb-item--field"
                style={{
                  borderTop: "0",
                  borderBottom: "1px solid rgba(131, 131, 131, 0.5)",
                }}
              >
                <label htmlFor="pwd">Password</label>
                <input
                  id="pwd"
                  type="password"
                  placeholder="Password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                />
              </div>
            </div>
            <button type="submit" className="circle-btn port-btn">
              <span className="button__bg"></span>Submit
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default BloggerLogin;
